var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-xl-4" }, [
    _c("article", { staticClass: "article-item home-featured" }, [
      _c("div", { staticClass: "article-wrap" }, [
        _c("div", { staticClass: "article-thumbnail" }, [
          _c("div", { staticClass: "img-box" }, [
            _c("a", { attrs: { href: _vm.getMatchLink(_vm.featuredTeam) } }, [
              _c("img", {
                staticClass: "lazy",
                attrs: {
                  src: "https://www.fantasygully.com/static-assets/images/cssimages/default-lazy-rect.png?w=130",
                  "data-src": _vm.getImageUrl(_vm.featuredTeam),
                  alt: _vm.featuredTeam.title_alias,
                },
              }),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "article-content" }, [
          _c("a", { attrs: { href: _vm.getMatchLink(_vm.featuredTeam) } }, [
            _c("div", { staticClass: "match-item" }, [
              _c("div", { staticClass: "match-data" }, [
                _c("div", { staticClass: "team team-A" }, [
                  _c("div", { staticClass: "team-name" }, [
                    _c("p", { staticClass: "article-title" }, [
                      _vm._v(_vm._s(_vm.featuredTeam.asset_title)),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }